<!--테스트 http://172.30.1.32:7777/nftOrderDetail?order_id=1490&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjM0NjIyMTIzMDkwIiwiZW1haWwiOiIiLCJuYW1lIjoi6rOg66y0IiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6bnVsbCwidXNlcl90eXBlIjoi7J2867CYIiwiaWF0IjoxNjM0NjIyMTIzLCJleHAiOjE3MjEwMjIxMjMsImlzcyI6Ii5vaC1iYWIuY29tIiwic3ViIjoidXNlckluZm8ifQ.3u8cGhlYDwHzwRZJv4XR4tfrk2m-15-y-BtknTUJZqs-->

<template>
  <section class="mobile_wrap">
    <div v-if="!isLoading"></div>
    <div v-else class="order__content">
      <div class="order__details">
        <p>주문완료</p>
        <ul class="product_list">
          <li>
            <dl class="item_subinfo">
              <dd>주문번호</dd>
              <dd v-html="order.id" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>주문시간</dd>
              <dd>
                {{ order.ago }}
              </dd>
              <!-- <dd>2021-02-02 14:06</dd> -->
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>연락처</dd>
              <dd>
                {{`${order.phone.substring(0, 3)}-${order.phone.substring(3, 7)}-${order.phone.substring(7, 11)}`}}
              </dd>
            </dl>
          </li>
        </ul>
      </div>
      <div class="order__details">
        <p>주문내역</p>
        <ul class="product_list">
          <li>
            <dl class="item_subinfo item__price">
              <dd class="ui-item-name" v-html="order.nft.serial_number" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo item__price">
              <dd class="ui-item-name" v-html="order.recipe.name" />
            </dl>
          </li>
        </ul>
      </div>
      <div class="order__details">
        <p>결제내역</p>
        <ul class="product_list">
          <li>
            <dl class="item_subinfo item__price">
              <dd>결제금액</dd>
              <dd>{{ price.toLocaleString("ko-KR") }}원</dd>
            </dl>
          </li>
          <li>
            <dl class="item_subinfo item__price">
              <dd>결제방식</dd>
              <dd>인앱결제</dd>
              <!-- <dd>{{ price.toLocaleString("ko-KR") }}원</dd> -->
            </dl>
          </li>
        </ul>
      </div>
      <div class="order__details">
        <p>{{order.price_difference ? '별도 결제내역' : '별도 환급내역'}}</p>
        <ul class="product_list">
          <li>
            <dl class="item_subinfo item__price">
              <dd>결제금액</dd>
              <dd>{{ ui_difference.toLocaleString("ko-KR") }}원</dd>
            </dl>
          </li>
          <li>
            <dl class="item_subinfo item__price">
              <dd>결제방식</dd>
              <dd>{{order.status == 'complete' ? '추가결제' : '결제대기'}}</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import client from "../client/client";
import { sweettrackerKey } from "../order/importpay";
import { useRoute } from 'vue-router'

export default {
  name: "orderDetail",
  data: () => ({
    isLoading: false,
    order: {},
    delivery: {},
    post: {},
    price: 1190000, //제품 가격
    ui_difference: 0,
  }),
  components: {},
  methods: {
    async update() {
      const route = useRoute()
      const { query } = route
      client.updateToken(query);
      let order = await client.get(`/api/nft/order/detail/${query.order_id}`);
      this.order = order.order;

      if(this.order.price_difference)
        this.ui_difference = this.order.price_difference;
      else
        this.ui_difference = 1190000 - this.order.price;

      this.isLoading = true;
    },
  },
  async mounted() {
    this.update();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";
.post_section{
  margin:10px 0 0;
  padding:12px 16px;
  list-style: none;
  display: flex;
  flex-flow: column-reverse;
  .step_item{
    &:first-child{
      &::before{
        display: none;
      }
    }
    &:last-child{
      &::after{
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F2632A' cx='10' cy='10' r='10'/%3E%3Cpath d='M14.148 6.303a.75.75 0 0 1 1.264.8l-.06.094-5.198 7a.75.75 0 0 1-1.067.142l-.077-.07-3.802-3.982a.75.75 0 0 1 1.002-1.11l.082.074 3.187 3.337 4.669-6.285Z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
        background-color:none;
        border:0;
        width:20px;
        height:20px;
        left:-6px;
        top:2px;
      }
    }
  }
  .step_item:before {
    position: absolute;
    left: 4px;
    top: 8px;
    bottom: -6px;
    border-left: 1px solid #d7dfe8;
    content: '';
  }

  .step_item:after {
    position: absolute;
    top: 5px;
    left: 1px;
    display: inline-block;
    width: 0.438rem;
    height: 0.438rem;
    vertical-align: top;
    background-color: #fff;
    border: 2px solid #d7dfe8;
    border-radius: 50%;
    content: '';
  }
  .delivery_info{
    position: relative;
    .state:before{
      display: inline-block;
      margin: 5px 6px 0 6px;
      vertical-align: top;
      width: 1px;
      height: 12px;
      background-color: #ccc;
      content: '';
    }
  }
  .step_item{
    padding:0 35px 15px 20px;
    position:relative;
  }
}
.ui-item-name{
  flex:1;
}
.ui-qty{
  padding:0 16px 0 8px;
}
.mt28 {
  margin-top: 28px !important;
}
.mt0 {
  margin-top: 0 !important;
}
body {
  background-color: #eee !important;
}
hr {
  margin: 30px 0;
  width: 100%;
  height: 10px;
  background: #f4f4f4;
  border: 0;
}
.order__details {
  margin: 28px 16px 0;
  &:first-child{
    margin-top: 0;
  }
  p {
    font-size: 14px;
    color: #343434;
    padding: 0;
    margin: 0 0 10px;
    font-weight: bold;
  }
  .amount__list {
    margin-top: 12px !important;
    padding-top: 12px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
  .product_list {
    padding: 16px 12px;
    margin: 0;
    background: #f4f4f4;
    border-radius: 6px;
    list-style: none;
    li {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
    .item_subinfo {
      display: flex;
      margin: 0px;
      flex-wrap: wrap;
      word-break: break-all;
      dd {
        font-size: 14px;
        color: #343434;
        margin: 0;
        &:first-child {
          flex-basis: 90px;
        }
      }
      &.item__price {
        dd {
          span {
            color: #f2632a;
            font-weight: bold;
          }
          &:last-child {
            margin-left: auto;
          }
        }
      }
    }
    &.address__info {
      dd {
        &:first-child {
          font-weight: bold;
        }
      }
    }
  }
}

.order__content {
  padding: 30px 0;
  width: 100%;
  flex-grow: 1;
}
.mobile_wrap {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  > div {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
}
</style>
